import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'

import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { getTranslationByPartnerAccess } from '../../../helpers/getTranslationByPartnerAccess'

import { ServiceDeliveryReadMode } from './components/serviceDeliveryReadMode/ServiceDeliveryReadMode'

import styles from './ServiceDelivery.module.scss'

interface IServiceDeliveryProps {
  isServiceDelivery: Nullable<boolean>
  isDistributor?: boolean
}

export const ServiceDelivery: FC<IServiceDeliveryProps> = ({
  isServiceDelivery,
  isDistributor,
}) => {
  const hintTranslationKey = getTranslationByPartnerAccess(
    'partnerbasicinfo-imps-service-delivery',
    {
      isDistributor,
    }
  )

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={hintTranslationKey} />
      <ServiceDeliveryReadMode isServiceDelivery={isServiceDelivery} />
    </div>
  )
}
